// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';
import { initMiniApp } from '@telegram-apps/sdk';
import { isDesktop } from 'react-device-detect';
import { TwaAnalyticsProvider } from '@tonsolutions/telemetree-react';

import HomePage from './pages/HomePage';
import JoinClan from './pages/JoinClan';
import Clan from './pages/Clan';
import Invite from './pages/Invite';
import Flip from './pages/Flip';
import Earn from './pages/Earn';
import Boosts from './pages/Boosts';
import Presale from './pages/Presale';
import Levels from './pages/Levels';
import BanPage from './pages/BanPage'
import './App.css';

const App = () => {
  const [miniApp] = initMiniApp();

  // const navigate = useNavigate();

  useEffect(() => {


    // console.log("This is moon coin");


    miniApp.setHeaderColor('#1b1e26');
    miniApp.isVerticalSwipesEnabled = false;

    window.Telegram.WebApp.expand();

    window.Telegram.WebApp.disableVerticalSwipes();

    // if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.disableVerticalSwipes) {
    //   window.Telegram.WebApp.disableVerticalSwipes();
    // } else {
    //   console.error('Telegram WebApp API is not available.');
    // }
  }, []);

  // useEffect(()=>{
  //   if(isDesktop){
  //       navigate('/ban');
  //   }
  // },[])
  return (
    <TwaAnalyticsProvider
      projectId='d19f03c4-2dcd-4632-b7cd-8863d5227c61'
      apiKey='31674d5a-174d-416e-bf4e-f1928d2da7d4'
      appName='Mooncoin'
    >
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path='/ban' element={<BanPage />} />
          <Route path='/joinclan' element={<JoinClan />} />
          <Route path='/joinClan/:id' element={<Clan />} />
          <Route path='/invite' element={<Invite />} />
          <Route path='/flip' element={<Flip />} />
          <Route path='/earn' element={<Earn />} />
          <Route path='/boosts' element={<Boosts />} />
          <Route path='/presale' element={<Presale />} />
          <Route path='/levels' element={<Levels />} />
        </Routes>
      </Router>
    </TwaAnalyticsProvider>
  );
};

export default App;
